//export const HOST = 'https://api.report-online.ru/api/v1' /*'http://79.174.82.170:8000/api/v1'*/
export const HOST = 'https://api.marketplaces.parsingsite.ru/api/v1'

export const HOST_GEO = 'https://lavka.parsingsite.ru/b-geo'
export const HOST_POINT = 'https://sale-lavka.parsingsite.ru'
//export const HOST_POINT = 'http://vm721214.vps.masterhost.tech:8080'
export const HOST_DEV = 'https://sec.parsingsite.ru/api/v1'

export const MAIN = '/'
export const AUTH = '/auth'
export const CHARTS = '/charts'
export const MAP = '/map'
export const NEWS = '/news'
export const DARK_STORE = '/darkstore'
export const SKU_FOOD = '/sku-food'
export const CATEGORY_FOOD = '/category-food'
export const INFO_POINT = `${MAP}/:id`
export const COMMERCE = '/commerce'

export const HEIGHT = 560     // высота графика
export const DELTA = 13     // максимальное изменение меток

export const FONT_SIZE_DATA_LABELS = '12px'

/*_________________________________________coefficients__________________________________*/

export const SAM_AKB_FACTOR = 700000  // смещение Самоката на графике «АКБ» (супермаркеты)
export const CATALOG_FACTOR = 40000000

/*_________________________________________АКБ chart tiers (только marketplaces)__________________________________*/

export const AKB_HIGH_TIER_NAMES = ['Wildberries', 'Ozon'] as const
export const AKB_HIGH_TIER_MIN = 25_000_000
export const AKB_LOW_TIER_MIN = 0
export const AKB_LOW_TIER_MAX = 30_000_000

export const isAkbHighTier = (name: string) =>
    (AKB_HIGH_TIER_NAMES as readonly string[]).includes(name)
